export type TimeSlot = {
	label: string;
	value: string;
};

export const generateTimeSlots = (): TimeSlot[] => {
	return Array.from({ length: 24 }, (_, hour) => {
		const paddedHour = hour.toString().padStart(2, '0');
		return {
			label: `${paddedHour}:00`,
			value: `${paddedHour}00`,
		};
	});
};
